"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "palagiano": {
    "26fec12b": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "skipSearch": false
    }],
    "cardnel-cardinale": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ab3d2343": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "skipSearch": false
    }],
    "chepvient-capovento": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8b363481": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "skipSearch": false
    }],
    "la-ngegn-3": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3f606f0e": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "skipSearch": false
    }],
    "la-chiazz-la-piazza": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9f956fab": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "skipSearch": false
    }],
    "la-chiesagrann-la-chiesa-madre": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8a6d734c": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "skipSearch": false
    }],
    "la-terr-la-terra": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b0d82749": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "skipSearch": false
    }],
    "la-vili-d-inprincp-la-villa-del-principe": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c204c3cf": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "skipSearch": false
    }],
    "rpddon": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "75343a17": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "skipSearch": false
    }],
    "u-cumment-il-convento": [{
      "hkey": "8634e6b3",
      "slug": "palagiano",
      "name": "Palagiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;